import React from 'react';
import { bool, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { shouldRenderCustomOrder } from '../../common/customOrder';
import { inMobileStickyExperience } from '../../utils/experiments/mobileStickyCta';
import { VARIANTS } from '../../types/variants';
import ContactSellerBtn from './ContactSellerBtn';
import ContactSellerOptions from './ContactSellerOptions';
import { MP_SOURCE_COMPONENT, BQ_SOURCE_NAME } from './constants';

import './style.scss';

const ContactSeller = ({ customOrder }, { general }) => {
    const context = getContext();
    const { userId } = context;
    const customOrderEligible = shouldRenderCustomOrder({
        userId,
        customOrder,
        general
    });

    const className = classNames(
        'contact-seller',
        { 'mobile-sticky-experience': inMobileStickyExperience({ context, general, variations: [VARIANTS.B, VARIANTS.C] }) }
    );

    return (
        <div className={className}>
            {customOrderEligible && <ContactSellerOptions/>}
            {!customOrderEligible &&
                <ContactSellerBtn titleKey="gig_page_perseus.contact_seller.title"
                    mixpanelSourceComponent={MP_SOURCE_COMPONENT}
                    bqSourceName={BQ_SOURCE_NAME}/>
            }
        </div>
    );
};

ContactSeller.propTypes = {
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

ContactSeller.defaultProps = {
    customOrder: {
        allowCustomOrders: true
    }
};

ContactSeller.contextTypes = {
    general: object
};

export { ContactSeller };
export default SafePureComponent(ContactSeller);
